import { UPDATE_UNREAD_COUNT } from "./actionTypes"

export const updateUnreadCount = count => {
  return {
    type: UPDATE_UNREAD_COUNT,
    payload: count,
  }
}
